import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

const EventsPage = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  useState(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  const handleNavigation = (link) => {
    if (link.path) {
      navigate(link.path);
    }
  };

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Events', path: '/events' },
    { name: 'Beliefs', path: '/beliefs' },
    { name: 'Resources', path: '/resources' },
  ];

  const upcomingEvents = [
    {
      id: 1,
      title: 'Sunday Worship Service',
      date: 'Every Sunday',
      time: '9:00 AM & 11:00 AM',
      location: 'Main Sanctuary',
      description: 'Join us for inspiring worship, powerful preaching, and fellowship with believers.',
      image: 'https://public.readdy.ai/ai/img_res/411c733cefdf13f6dd7d4344be1f9f43.jpg',
      category: 'Worship'
    },
    {
      id: 2,
      title: 'Youth Night',
      date: 'Every Friday',
      time: '7:00 PM - 9:00 PM',
      location: 'Youth Center',
      description: 'Dynamic worship, relevant teaching, and fun activities for teens and young adults.',
      image: 'https://readdy.ai/api/search-image?query=energetic%20youth%20group%20gathering%20with%20teenagers%20playing%20games%20and%20worshiping%20together%2C%20modern%20youth%20center%20with%20colorful%20lighting%2C%20young%20people%20laughing%20and%20connecting%20in%20faith%2C%20contemporary%20Christian%20youth%20ministry%20setting%2C%20vibrant%20and%20engaging%20atmosphere&width=800&height=500&seq=events2&orientation=landscape',
      category: 'Youth'
    },
    {
      id: 3,
      title: 'Prayer Meeting',
      date: 'Every Wednesday',
      time: '6:30 PM - 8:00 PM',
      location: 'Prayer Room',
      description: 'Come together in prayer for our church, community, and world.',
      image: 'https://readdy.ai/api/search-image?query=peaceful%20prayer%20gathering%20with%20people%20holding%20hands%20in%20circle%2C%20soft%20candlelight%20and%20serene%20atmosphere%2C%20diverse%20group%20praying%20together%20in%20unity%2C%20intimate%20worship%20space%20with%20warm%20ambient%20lighting%2C%20spiritual%20connection%20and%20community%20prayer%20time&width=800&height=500&seq=events3&orientation=landscape',
      category: 'Prayer'
    },
    {
      id: 4,
      title: 'Community Outreach',
      date: 'Last Saturday of Month',
      time: '10:00 AM - 2:00 PM',
      location: 'Various Locations',
      description: 'Serve our community through food distribution, home repairs, and neighborhood care.',
      image: 'https://readdy.ai/api/search-image?query=volunteers%20serving%20community%20with%20food%20distribution%20and%20helping%20neighbors%2C%20people%20working%20together%20in%20service%20projects%2C%20diverse%20group%20showing%20compassion%20and%20care%2C%20outdoor%20community%20service%20event%20with%20smiling%20volunteers%2C%20hands%20reaching%20out%20to%20help%20others%20in%20need&width=800&height=500&seq=events4&orientation=landscape',
      category: 'Outreach'
    },
    {
      id: 5,
      title: 'Bible Study Groups',
      date: 'Every Tuesday & Thursday',
      time: '7:00 PM - 8:30 PM',
      location: 'Small Group Rooms',
      description: 'Dive deeper into God\'s Word with small group discussions and fellowship.',
      image: 'https://readdy.ai/api/search-image?query=small%20group%20bible%20study%20with%20people%20sitting%20in%20circle%20discussing%20scripture%2C%20open%20bibles%20and%20coffee%20cups%20on%20table%2C%20warm%20and%20welcoming%20home%20setting%2C%20diverse%20believers%20learning%20together%2C%20intimate%20fellowship%20and%20spiritual%20growth%20atmosphere&width=800&height=500&seq=events5&orientation=landscape',
      category: 'Study'
    },
    {
      id: 6,
      title: 'Women\'s Fellowship Brunch',
      date: 'First Saturday',
      time: '10:00 AM - 12:00 PM',
      location: 'Fellowship Hall',
      description: 'Connect with other women through food, fellowship, and inspiring messages.',
      image: 'https://readdy.ai/api/search-image?query=women%20gathering%20for%20brunch%20fellowship%20with%20elegant%20table%20setting%2C%20ladies%20laughing%20and%20connecting%20over%20meal%2C%20warm%20and%20inviting%20atmosphere%2C%20diverse%20women%20of%20faith%20sharing%20stories%2C%20beautiful%20brunch%20spread%20with%20flowers%20and%20natural%20light&width=800&height=500&seq=events6&orientation=landscape',
      category: 'Fellowship'
    }
  ];

  const specialEvents = [
    {
      id: 7,
      title: 'Easter Celebration Service',
      date: 'April 20, 2025',
      time: '9:00 AM & 11:00 AM',
      location: 'Main Sanctuary',
      description: 'Celebrate the resurrection of Jesus Christ with special music, drama, and powerful preaching.',
      image: 'https://readdy.ai/api/search-image?query=easter%20church%20celebration%20with%20beautiful%20floral%20decorations%20and%20cross%2C%20joyful%20congregation%20celebrating%20resurrection%2C%20bright%20and%20festive%20sanctuary%20filled%20with%20lilies%20and%20spring%20flowers%2C%20people%20dressed%20in%20their%20best%20celebrating%20new%20life%20in%20Christ&width=800&height=500&seq=events7&orientation=landscape',
      category: 'Special'
    },
    {
      id: 8,
      title: 'Summer Family Camp',
      date: 'July 15-19, 2025',
      time: 'All Day',
      location: 'Mountain Retreat Center',
      description: 'Five days of worship, teaching, recreation, and family bonding in God\'s creation.',
      image: 'https://readdy.ai/api/search-image?query=family%20church%20camp%20in%20beautiful%20mountain%20setting%20with%20cabins%20and%20outdoor%20activities%2C%20families%20worshiping%20together%20around%20campfire%2C%20children%20playing%20and%20parents%20connecting%2C%20scenic%20nature%20retreat%20with%20lake%20and%20forest%2C%20joyful%20Christian%20camping%20experience&width=800&height=500&seq=events8&orientation=landscape',
      category: 'Special'
    },
    {
      id: 9,
      title: 'Back to School Blessing',
      date: 'August 10, 2025',
      time: '10:00 AM - 12:00 PM',
      location: 'Church Parking Lot',
      description: 'Free school supplies, backpacks, and prayer for students and teachers.',
      image: 'https://readdy.ai/api/search-image?query=church%20volunteers%20distributing%20school%20supplies%20and%20backpacks%20to%20children%2C%20families%20receiving%20blessings%20and%20prayer%20for%20new%20school%20year%2C%20colorful%20backpacks%20and%20school%20supplies%20displayed%2C%20community%20gathering%20with%20smiling%20kids%20and%20grateful%20parents&width=800&height=500&seq=events9&orientation=landscape',
      category: 'Special'
    }
  ];

  const [selectedCategory, setSelectedCategory] = useState('All');
  const categories = ['All', 'Worship', 'Youth', 'Prayer', 'Outreach', 'Study', 'Fellowship', 'Special'];

  const filteredEvents = selectedCategory === 'All' 
    ? [...upcomingEvents, ...specialEvents]
    : [...upcomingEvents, ...specialEvents].filter(event => event.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <div className="w-20 h-20 bg-black rounded-2xl flex items-center justify-center mx-auto mb-6">
              <i className="ri-calendar-event-line text-4xl text-white"></i>
            </div>
            <h1 className="text-5xl font-bold text-black mb-6">Church Events & Activities</h1>
            <p className="text-lg text-gray-600 leading-relaxed">
              Join us for worship, fellowship, and service opportunities. There's something for everyone in our church family!
            </p>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-gray-50 border-y border-gray-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-black text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Events Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredEvents.map((event) => (
              <div
                key={event.id}
                className="bg-gray-50 rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all border border-gray-200 group"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={event.image}
                    alt={event.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4">
                    <span className="bg-black text-white px-4 py-1 rounded-full text-xs font-semibold">
                      {event.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-black mb-3">{event.title}</h3>
                  <div className="space-y-2 mb-4">
                    <div className="flex items-center text-sm text-gray-600">
                      <i className="ri-calendar-line mr-2 text-black"></i>
                      {event.date}
                    </div>
                    <div className="flex items-center text-sm text-gray-600">
                      <i className="ri-time-line mr-2 text-black"></i>
                      {event.time}
                    </div>
                    <div className="flex items-center text-sm text-gray-600">
                      <i className="ri-map-pin-line mr-2 text-black"></i>
                      {event.location}
                    </div>
                  </div>
                  <p className="text-sm text-gray-600 leading-relaxed mb-4">
                    {event.description}
                  </p>
                  <button className="w-full bg-black hover:bg-gray-900 text-white py-2 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer">
                    Register Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-black mb-4">Stay Connected</h2>
          <p className="text-gray-600 mb-8 leading-relaxed">
            Never miss an event! Subscribe to our newsletter to receive updates about upcoming activities, special services, and community gatherings.
          </p>
          <button className="bg-black hover:bg-gray-900 text-white px-8 py-3 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer">
            Subscribe to Newsletter
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default EventsPage;
